import { AgeCalculationInput } from './types';

export const AgeCaluculation = ({
    year,
    month,
    currentDate,
}: AgeCalculationInput) => {
    if (!year || !month) return null;

    const yearNum = typeof year === 'string' ? parseInt(year, 10) : year;
    const monthNum = typeof month === 'string' ? parseInt(month, 10) : month;
    const birthDate = new Date(yearNum, monthNum - 1);
    const today = new Date(currentDate);

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }

    return age;
};
